import React from 'react';
import './Hero.css';
import truckImage from '../assets/cpt-truck.png';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero" id="accueil">
      <div className="hero-bg"></div>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-tag">Transport & Placement</div>
          <h1>CPT EXPRESS<span>Rapide. Fiable. Professionnel.</span></h1>
          <p className="hero-description">
            Votre partenaire de confiance pour le transport express et le placement de chauffeurs qualifiés. 
            Solutions adaptées aux besoins de votre entreprise.
          </p>
          <a href="#contact" className="hero-cta" onClick={scrollToContact}>
            Contactez-nous
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>
        <div className="hero-visual">
          <div className="hero-image">
            <img src={truckImage} alt="Camion CPT Express" />
          </div>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Disponibilité</div>
            </div>
            <div className="stat">
              <div className="stat-number">100%</div>
              <div className="stat-label">Fiabilité</div>
            </div>
            <div className="stat">
              <div className="stat-number">MTL</div>
              <div className="stat-label">Basé à Montréal</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
